export default __webpack_public_path__ + "media/zurb/img/services/tools/helio-screenshot1-b9cbb69e911c0b4e31053883bfd5e1d8.png";